module.exports = __webpack_public_path__ + "static/vicmap-carto-icon-afdbcfee7af87a2f025d8ae720d11c42.png";